import * as actiontypes from '../actions/actionTypes';
import initialState from '../store/initialState';

const config = (state = initialState.config, action) => {
    switch (action.type) {
        case actiontypes.SAVE_CONFIG:

            return action.config
        default:
            return state
    }
}

export default config


// WEBPACK FOOTER //
// ./src/reducers/configReducer.js